// ============================================================
// TILT : SpriteManifest.js          (the Mark's portrait source)
// The shared Mark reads PLAYER_SPRITES for the portrait on your card. Tilt has no player sprites of its own (it is a pinball
// table), so it borrows the Empire's two default players (caP'n, 2026-10-25: "Lyraei and Laostre" in every project):
//   f = Lyraei, m = Laostre (Terror's two player bodies; Terror's art drop spells him "Lestre").
// ONE constant for the asset domain, per the CDN law. The files are Terror's own resting-pose sprites on its asset project.
// ============================================================
const TERROR_ASSETS = "https://terror-assets.pages.dev";
export const PLAYER_SPRITES = {
  player_f_default: `${TERROR_ASSETS}/player_f_rest_down.webp`,   // Lyraei
  player_m_default: `${TERROR_ASSETS}/player_m_rest_down.webp`,   // Laostre
};
